import { faClose, FaIcon, faUserSolid,  } from '@/lib/fa'
import * as React from 'react'
import Navigation from '../shared/Navigation'
import { useContractForm } from '../../context/ContractFormContext'
import { SubNavigationBar } from '@/modules/shared/components'

const ContractHeader = ({ driverNames, close }: {driverNames: string[], close: () => void}) => {
  const { formTab, setFormTab, allTabs, isEditState, isAnnexState } =
    useContractForm()
  return (
    <>
      <div className="tw-ring-b tw-ring-base-100">
        <div className={`tw-flex tw-flex-col tw-gap-4 tw-py-4 tw-pb-0`}>
          <div className="tw-flex tw-items-center tw-justify-between tw-px-4">
            <div className="tw-flex tw-items-center tw-gap-2">
              <p className="tw-gap-2 tw-text-xl tw-font-semibold tw-text-content-base">
                {isEditState
                  ? `Edycja ${isAnnexState ? 'aneksu' : 'umowy'}`
                  : `Dodawanie ${isAnnexState ? 'aneksu' : 'umowy'}`}
              </p>
              {driverNames?.slice(0, 2).map((driverName) => (
                <div
                  key={driverName}
                  className="tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-bg-base-300 tw-px-1 tw-py-1"
                >
                  <FaIcon
                    icon={faUserSolid}
                    className="tw-h-3 tw-w-3"
                    onClick={() => close()}
                  />
                  <p className="tw-text-xs tw-text-content-base">
                    {driverName}
                  </p>
                </div>
              ))}

              {driverNames.length > 2 && (
                <p className="tw-rounded-full tw-bg-base-300 tw-p-1 tw-px-2 tw-text-xs tw-text-content-base">
                  +{driverNames.length - 2}
                </p>
              )}
            </div>
            <FaIcon
              icon={faClose}
              className="tw-h-5 tw-w-5 tw-cursor-pointer"
              onClick={() => close()}
            />
          </div>

          <SubNavigationBar>
            {allTabs.map((tab) => (
              <Navigation
                key={tab.type}
                isActive={formTab === tab.type}
                onClick={() => setFormTab(tab.type)}
              >
                {tab.label}
              </Navigation>
            ))}
          </SubNavigationBar>
        </div>
      </div>
    </>
  )
}

export default ContractHeader
